export const chatInviteFragment = `
  fragment ChatInviteFragment on ChatInvite {
    id
    companyId
    createdAt
    createdBy
    createdByAccount {
      ...AccountFragment
    }

    code
    url
    personId
    isAccepted
    expiresAt
  }
`;
